import React, {useEffect, useState} from "react";
import Stack from "components/elements/stack/Stack";
import Voices from "../Voices";
import AudioPlayer from "components/elements/AudioPlayer";
import EventBus from "common/EventBus";
import {setActiveVoice} from "hooks/useActiveVoice";
import {Voice} from "types/Voice";

export interface VoicesSelectProps {
    show: boolean
    voices: Voice[]
    onClose: (item: any) => void
}

const VoicesSelect: React.FC<VoicesSelectProps> = ({
    show,
    voices,
    onClose
}) => {
    const [showAdd, setShowAdd] = useState<boolean>(false)
    const [selectedVoices, setSelectedVoices] = useState<Voice[]>([])

    useEffect(() => {
        setSelectedVoices([])
        setShowAdd(show)

        if (show) {
            EventBus.dispatch("stackOpen", null)
        } else {
            EventBus.dispatch("stackClosed", null)
        }
    }, [show])

    const changeHandler = (e: Voice[]) => {
        setSelectedVoices(e)
    }

    const close = () => {
        setShowAdd(false)
        onClose(null)
        resetData()
    }

    const handleSubmit = (selectedVoices: Voice[]) => {
        setShowAdd(false)
        onClose(selectedVoices)
        resetData()
    }

    const resetData = () => {
        setActiveVoice(null)
    }

    return (
        <Stack size="full" isShow={showAdd} onClose={() => close()} title="Select the voices">
            <div className="px-4 sm:px-6 md:px-8 mt-12 mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 h-8 mb-4">Add voices to your project</h3>
                <p className="text-sm mb-0">Select the voices that you would like to add to your project.</p>
            </div>
            <div className="mt-[58px]">
                <Voices 
                    selectableVoices={true} 
                    selectedVoices={voices} 
                    onChange={changeHandler}
                    onSubmit={handleSubmit}
                />
            </div>
            
            <AudioPlayer inStack={true}/>
        </Stack>
    )
}

export default VoicesSelect